/*
  JILZARAH — shared cart bridge for the guided pages (custom, not part of Flex)

  The World of Color and Christmas pages used to keep a browser-side "assortment" and send it
  to the cart in one request. That read as a second cart. Now the Shopify cart is the only
  cart: every stepper on those pages writes straight through this module, and every count
  and subtotal they show is read back from it.

  window.JZCart
    load()            → fetch /cart.js, remember it, notify subscribers (also runs after any
                        jQuery cart call the theme makes — the drawer's quantity box and remove
                        link — and when the tab regains focus). Resolves with the cart, or with
                        null when it could not be read: the cart remembered from before is kept
                        (get() and qty() still answer from it), but a caller that needs to know
                        what is really there must not mistake it for a fresh read
    qty(variantId)    → the quantity the buyer intends: a pending edit if there is one,
                        otherwise the quantity in the cart
    set(variantId, n) → queue an absolute quantity (0 removes); edits made within a short
                        burst go to /cart/update.js as one request
    on(fn) / onError(fn)  → subscribe to cart changes / to failed updates (stock caps,
                        network); after a failure the cart is re-read so every page snaps
                        back to the truth
    open(before)      → refresh the theme's header count and drawer, then open the Flex cart
                        drawer (falls back to the cart page when the theme is not in drawer
                        mode); `before` runs first so a page can close its own drawer
    openSoon()        → open the Flex cart drawer once the pending edits have landed
                        (available, but the pages no longer call it: Rafael preferred the
                        cart to stay closed on every action — Add gives a toast instead)
    refresh()         → PXUTheme.jsAjaxCart.updateView(): header count + drawer contents

  /cart/update.js keyed by variant id sets an absolute quantity, adds the variant when it is
  not in the cart yet, and leaves every other line alone. A 422 (over stock) fails the whole
  request, which is why a failure is followed by a re-read rather than a guess.
*/
(function () {
  'use strict';
  if (window.JZCart) return;

  var cart = null, pending = {}, inflight = null, timer = null, again = false, openAfter = false;
  var subs = [], errs = [];
  var DEBOUNCE = 220;

  function root() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return r.replace(/\/?$/, '/'); }
  function headers() { return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }; }
  function emit() { subs.forEach(function (fn) { try { fn(cart); } catch (e) {} }); }
  function fail(msg) { errs.forEach(function (fn) { try { fn(msg); } catch (e) {} }); }

  function load() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) { if (c && c.items) { cart = c; emit(); return cart; } return null; })
      .catch(function () { return null; });
  }

  function inCart(variantId) {
    if (!cart) return 0;
    var n = 0; cart.items.forEach(function (i) { if (String(i.variant_id) === String(variantId)) n += i.quantity; });
    return n;
  }
  function qty(variantId) {
    var k = String(variantId);
    if (pending[k] !== undefined) return pending[k];
    if (inflight && inflight.updates[k] !== undefined) return inflight.updates[k];
    return inCart(k);
  }

  function set(variantId, n) {
    pending[String(variantId)] = Math.max(0, Math.round(n) || 0);
    clearTimeout(timer); timer = setTimeout(flush, DEBOUNCE);
  }

  function flush() {
    if (inflight) { again = true; return; }
    var updates = pending; pending = {};
    var keys = Object.keys(updates);
    /* drop edits that already match the cart */
    keys.forEach(function (k) { if (updates[k] === inCart(k)) delete updates[k]; });
    if (!Object.keys(updates).length) { if (openAfter) { openAfter = false; show(); } return; }
    inflight = { updates: updates };
    fetch(root() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: headers(), body: JSON.stringify({ updates: updates }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (res.ok && res.body && res.body.items) {
          cart = res.body; inflight = null; emit(); refresh();
          if (openAfter && !Object.keys(pending).length) { openAfter = false; show(); }
        }
        else {
          inflight = null; openAfter = false;
          var d = res.body && (res.body.description || res.body.message);
          fail(typeof d === 'string' && d ? d : 'The cart could not be updated.');
          return load();
        }
      })
      .catch(function () { inflight = null; openAfter = false; fail('We could not reach the cart. Check your connection and try again.'); return load(); })
      .then(function () { if (again || Object.keys(pending).length) { again = false; flush(); } });
  }

  function refresh() {
    var ac = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    if (ac && typeof ac.updateView === 'function') { try { ac.updateView(); } catch (e) {} }
  }
  function show() {
    var ac = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    if (ac && ac.cart_action === 'drawer' && typeof ac.showDrawer === 'function') { try { ac.showDrawer(); } catch (e) {} }
  }
  function openSoon() { openAfter = true; }
  function open(before) {
    if (typeof before === 'function') { try { before(); } catch (e) {} }
    var ac = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    var drawer = ac && ac.cart_action === 'drawer' && typeof ac.showDrawer === 'function';
    if (drawer) { try { ac.updateView(); ac.showDrawer(); return; } catch (e) {} }
    window.location.href = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || (root() + 'cart');
  }

  document.addEventListener('visibilitychange', function () { if (!document.hidden && cart) load(); });

  /* The theme's own cart drawer edits the cart behind the page's back (quantity box, remove
     link). Every one of those goes through jQuery's $.ajax to /cart/change.js, so one global
     hook re-reads the cart and the page's steppers follow. Our own writes use fetch, so this
     never fires for them. */
  var hooked = false;
  function hookTheme() {
    var jq = window.jQuery; if (hooked || !jq || !jq.fn) return; hooked = true;
    jq(document).ajaxComplete(function (e, xhr, opts) {
      var u = (opts && opts.url) || '';
      if (/\/cart\/(change|add|update|clear)(\.js)?(\?|$)/.test(u)) load();
    });
  }
  hookTheme();
  if (!hooked) document.addEventListener('DOMContentLoaded', hookTheme);
  if (!hooked) window.addEventListener('load', hookTheme);

  /* cart lines that belong to none of the given variants — "and 3 other items in your cart" */
  function others(variantIds) {
    if (!cart) return 0;
    var mine = {}; (variantIds || []).forEach(function (v) { mine[String(v)] = 1; });
    return cart.items.filter(function (i) { return !mine[String(i.variant_id)]; }).length;
  }

  window.JZCart = {
    load: load, qty: qty, set: set, refresh: refresh, open: open, openSoon: openSoon, others: others,
    drawerOpen: function () { return !!document.querySelector('#theme-ajax-cart.is-drawer.is-visible'); },
    on: function (fn) { subs.push(fn); if (cart) fn(cart); },
    onError: function (fn) { errs.push(fn); },
    get: function () { return cart; },
  };
})();
